(function AdzukiClientForm($, Adzuki)
{
	'use strict';

	const component = {
		emits   : ['client-selected', 'client-updated'],
		template: `
			<div class="adzuki-client-form">
				<div v-if="!selectedClient && !showForm" class="client-selection margin10-bottom">
					<button
						class="btn btn-primary pad10-right"
						@click="showSearchMode"
					>
						Search Existing Client
					</button>
					<button
						class="btn btn-primary"
						@click="showAddMode"
					>
						Add New Client
					</button>
				</div>

				<!-- Existing Client Search -->
				<div v-if="mode === 'search'" class="existing-client-search">
					<div class="form-group">
						<label class="control-label">Search Client</label>
						<input
							type="text"
							placeholder="Start typing client name..."
							class="form-control"
							v-model="searchTerm"
							@input="handleSearchInput"
							autocomplete="off"
						/>
						<ul
							v-if="showSuggestions && suggestions.length > 0"
							class="suggestion-list"
						>
							<li
								v-for="client in suggestions"
								:key="client.id"
								@click="selectClient(client)"
								class="suggestion-item"
							>
								{{ client.name }}
							</li>
						</ul>
					</div>
					<button
						v-if="!selectedClient"
						class="btn btn-default btn-sm"
						@click="cancelSearch"
					>
						Cancel
					</button>
				</div>

				<!-- Client Form (for new or edit) -->
				<div v-if="showForm" class="client-form">
					<div class="panel panel-default">
						<div class="panel-body">
							<div class="row">
								<div class="col-sm-2">
									<div class="form-group">
										<label class="control-label">Title</label>
										<select v-model="clientForm.title" class="form-control">
											<option value="">Select</option>
											<option value="Mr">Mr</option>
											<option value="Mrs">Mrs</option>
											<option value="Ms">Ms</option>
											<option value="Dr">Dr</option>
											<option value="Prof">Prof</option>
										</select>
									</div>
								</div>
								<div class="col-sm-4">
									<div class="form-group">
										<label class="control-label">First Name *</label>
										<input type="text" class="form-control" v-model="clientForm.first_name">
									</div>
								</div>
								<div class="col-sm-4">
									<div class="form-group">
										<label class="control-label">Last Name *</label>
										<input type="text" class="form-control" v-model="clientForm.last_name">
									</div>
								</div>
								<div class="col-sm-2">
									<div class="form-group">
										<label class="control-label">Suffix</label>
										<input type="text" class="form-control" v-model="clientForm.suffix">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-6">
									<div class="form-group">
										<label class="control-label">Email *</label>
										<input type="email" class="form-control" v-model="clientForm.email">
									</div>
								</div>
								<div class="col-sm-6">
									<div class="form-group">
										<label class="control-label">Phone *</label>
										<input type="tel" class="form-control" v-model="clientForm.phone">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12">
									<div class="form-group">
										<label class="control-label">Address 1</label>
										<input type="text" class="form-control" v-model="clientForm.address1">
									</div>
								</div>
								<div class="col-sm-12">
									<div class="form-group">
										<label class="control-label">Address 2</label>
										<input type="email" class="form-control" v-model="clientForm.address2">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-5">
									<div class="form-group">
										<label class="control-label">City</label>
										<input type="tel" class="form-control" v-model="clientForm.city">
									</div>
								</div>
								<div class="col-sm-5">
									<div class="form-group">
										<label class="control-label">State</label>
										<input type="tel" class="form-control" v-model="clientForm.state_iso">
									</div>
								</div>
								<div class="col-sm-5">
									<div class="form-group">
										<label class="control-label">Country</label>
										<input type="tel" class="form-control" v-model="clientForm.country">
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12">
									<button
										v-if="isEditMode"
										class="btn btn-primary"
										@click="updateClient"
									>
										<i class="fa fa-save"></i> Update Client
									</button>
									<button
										v-else
										class="btn btn-success"
										@click="addClient"
									>
										<i class="fa fa-plus"></i> Add Client
									</button>
									<button
										class="btn btn-default"
										@click="cancelForm"
									>
										Cancel
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
		`,
		props: {
			// Pass in an existing client to edit
			client: {
				type   : Object,
				default: null,
			},
		},
		data() {
			return {
				baseUri        : Adzuki.base_uri,
				mode           : null, // 'search' or 'add'
				showForm       : false,
				isEditMode     : false,
				searchTerm     : '',
				selectedClient : null,
				clientForm     : this.getEmptyClientForm(),
				showSuggestions: false,
				suggestions    : [],
				debounceTimer  : null,
			};
		},
		methods: {
			getEmptyClientForm() {
				return {
					id        : null,
					title     : '',
					first_name: '',
					last_name : '',
					suffix    : '',
					email     : '',
					phone     : '',
					address1  : '',
					address2  : '',
					city      : '',
					state     : '',
					zip       : '',
					country   : '',
				};
			},
			showSearchMode() {
				this.mode            = 'search';
				this.showForm        = false;
				this.isEditMode      = false;
				this.searchTerm      = '';
				this.suggestions     = [];
				this.showSuggestions = false;
			},
			showAddMode() {
				this.mode       = 'add';
				this.showForm   = true;
				this.isEditMode = false;
				this.clientForm = this.getEmptyClientForm();
			},
			cancelSearch() {
				this.mode            = null;
				this.searchTerm      = '';
				this.suggestions     = [];
				this.showSuggestions = false;
			},
			cancelForm() {
				this.mode       = null;
				this.showForm   = false;
				this.isEditMode = false;
				this.clientForm = this.getEmptyClientForm();
			},
			handleSearchInput() {
				if (this.debounceTimer) {
					clearTimeout(this.debounceTimer);
				}

				if (this.searchTerm.length > 2) {
					this.debounceTimer = setTimeout(() => {
						this.fetchClientSuggestions();
					}, 300);
				} else {
					this.suggestions     = [];
					this.showSuggestions = false;
				}
			},
			async fetchClientSuggestions() {
				try {
					const response = await fetch(
						`${this.baseUri}/Searches/client/${encodeURIComponent(this.searchTerm)}`
					);

					if (!response.ok) {
						throw new Error("Failed to fetch client suggestions");
					}

					const data = await response.json();
					this.suggestions     = Array.isArray(data) ? data : [];
					this.showSuggestions = this.suggestions.length > 0;
				} catch (error) {
					console.error("Error fetching client suggestions:", error);
					this.suggestions     = [];
					this.showSuggestions = false;
				}
			},
			async selectClient(client) {
				try {
					// Fetch full client details
					const response = await fetch(
						`${this.baseUri}/Clients/getClientDetailsVue/${client.id}`
					);

					if (!response.ok) {
						throw new Error("Failed to fetch client details");
					}

					const clientDetails = await response.json();

					// Map to our form structure
					this.selectedClient = {
						id          : client.id,
						title       : clientDetails.general?.prefix || '',
						first_name  : clientDetails.general?.first_name || '',
						last_name   : clientDetails.general?.last_name || '',
						suffix      : clientDetails.general?.suffix || '',
						email       : clientDetails.general?.email || '',
						phone       : clientDetails.general?.mobile_phone || '',
						_fullDetails: clientDetails,
					};

					// Hide search UI
					this.mode            = null;
					this.searchTerm      = '';
					this.suggestions     = [];
					this.showSuggestions = false;

					// Emit to parent
					this.$emit('client-selected', this.selectedClient);
				} catch (error) {
					console.error("Error selecting client:", error);
					alert("Error loading client details");
				}
			},
			editClient() {
				this.isEditMode = true;
				this.showForm   = true;
				this.mode       = 'edit';
				// Populate form with selected client
				this.clientForm = { ...this.selectedClient };
			},
			addClient() {
				if (!this.validateForm()) {
					return;
				}

				// Emit new client data to parent
				const newClient = { ...this.clientForm };
				this.selectedClient = newClient;
				this.showForm = false;
				this.mode = null;

				this.$emit('client-selected', newClient);
			},
			updateClient() {
				if (!this.validateForm()) {
					return;
				}

				// Update selected client
				this.selectedClient = { ...this.clientForm };
				this.showForm = false;
				this.mode = null;
				this.isEditMode = false;

				this.$emit('client-updated', this.selectedClient);
			},
			clearClient() {
				this.selectedClient = null;
				this.clientForm = this.getEmptyClientForm();
				this.mode = null;
				this.showForm = false;

				this.$emit('client-selected', null);
			},
			validateForm() {
				if (!this.clientForm.first_name || !this.clientForm.last_name) {
					alert('First name and last name are required');
					return false;
				}
				if (!this.clientForm.email) {
					alert('Email is required');
					return false;
				}
				if (!this.clientForm.phone) {
					alert('Phone is required');
					return false;
				}
				return true;
			},
			getClientDisplayName(client) {
				const parts = [
					client.title,
					client.first_name,
					client.last_name,
					client.suffix
				].filter(Boolean);
				return parts.join(' ');
			},
			populateFromProp() {
				if (this.client) {
					this.selectedClient = { ...this.client };
					this.mode = null;
					this.showForm = false;
				}
			}
		},
		watch: {
			client: {
				handler() {
					this.populateFromProp();
				},
				immediate: true,
			},
		},
		mounted() {
			this.populateFromProp();
		}
	};

	Adzuki.VueComponents.AdzukiClientForm = component;
}(jQuery, window.Adzuki || {}));